
import '@/style/index';
import 'antd/dist/reset.css';
import 'dayjs/locale/zh-cn';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
const root = ReactDOM.createRoot(document.getElementById('root'));

// 从环境变量读取标题（通过 .env 设置 REACT_APP_TITLE），若无则保持 HTML 中默认标题
if (process.env.REACT_APP_TITLE) {
    document.title = process.env.REACT_APP_TITLE;
}

root.render(
    <ConfigProvider
        locale={zhCN}
        theme={{
            token: {
                colorPrimary: '#1890ff',
            },
            components: {
                Table: {
                    headerBg: '#1890ff',
                    headerColor: '#fff',
                },
                Layout:{
                    headerBg: '#1890ff',
                    headerPadding:"0"
                }
            },
            
        }}
    >
        <App />
    </ConfigProvider>
);